import { useWatchlistContext } from "@/context/use-context/watchlist-provider/client";
import { toggleWatchlist } from "@/features/analysis/layouts/service/toggle-watchlist";

export const Backdrop = () => {
  const { isOpen, setIsOpen } = useWatchlistContext();

  const onClick = () => {
    toggleWatchlist({ isOpen });
    setIsOpen(!isOpen);
  };

  return (
    <div
      className="fixed inset-0 z-20 bg-black/30 sm:hidden"
      onClick={onClick}
    />
  );
};
